import CircularProgress from "@material-ui/core/CircularProgress";
import React, { useContext, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";

import AuthContext from "../../store/auth-context";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useTranslation } from "react-i18next";

const ConsultedDoctorsCard = (props: any) => {
  const [t] = useTranslation();
  const authCtx = useContext(AuthContext);
  const history = useHistory();
  const [isError, setIsError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<any>("");
  const [docLoder, setDocLoder] = useState<any>(false);
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const locationList: any = authCtx.locationGlobalList;

  useEffect(() => {}, [authCtx.isDobAvailable, authCtx.consultedDoctorList]);

  const reBookAppointment = async (item: any) => {
    history.push({ pathname: "/auth/bookappointment/", state: item });
  };

  return (
    <>
      <div
        className={
          "card border-0 shadow-sm rounded-1rem " +
          (props.topMargin ? "mt-4 mt-md-0" : "mb-4")
        }
      >
        <div className="card-body p-0 ">
          <h6 className="fw-bold text-primary p-4 mb-0">
            {t("Recently consulted Doctors")}
          </h6>
          <div className="consultedoverflow primary-scroll p-3 pt-0">
            {authCtx.consultedDoctorList &&
              authCtx.consultedDoctorList.map((item: any, index: any) => (
                <React.Fragment key={index}>
                  {" "}
                  <div
                    className={
                      index === 0
                        ? "d-flex align-items-center"
                        : "d-flex mt-4 align-items-center"
                    }
                  >
                    <div className="flex-shrink-0">
                      <img
                        src={item.image}
                        className="img-h-60 rounded-circle dr-photo"
                        alt="dr-img"
                      />{" "}
                    </div>
                    <div className="flex-grow-1 ms-2">
                      <label className="fw-bold">{item.name}</label>
                      {item.scheduleType === "TELEMED" ? (
                        <p className="text-muted fs-12 m-0">
                          {t("General Practitioner")}
                        </p>
                      ) : (
                        <>
                          <p className="text-muted fs-12 m-0">
                            {item.specialty}
                          </p>
                          <p className="text-muted fs-12 m-0">
                            {item.location}
                          </p>
                        </>
                      )}
                    </div>
                    {item.appointment_message === null ||
                    item.appointment_message.trim() === "" ? (
                      item.scheduleType === "TELEMED" ? (
                        <Link
                          to={{
                            pathname: "/auth/scheduleBooking",
                            state: item,
                          }}
                          className="btn btn-primary btn-sm w-77 no-focus"
                        >
                          {t("Re-book")}
                        </Link>
                      ) : (
                        <button
                          onClick={() => reBookAppointment(item)}
                          className="btn btn-primary btn-sm w-77 no-focus"
                        >
                          {t("Re-book")}
                        </button>
                      )
                    ) : (
                      <a
                        className="btn btn-primary btn-sm w-77 fw-8"
                        href={`tel: ${item.appointment_message}`}
                      >
                        <img
                          className="pb-1"
                          src={"/assets/images/phone_white.png"}
                        />
                        {item.appointment_message}
                      </a>
                    )}
                  </div>
                </React.Fragment>
              ))}
          </div>
          {authCtx.consultedDoctorList &&
            authCtx.consultedDoctorList.length === 0 && (
              <div className="mh-240p d-flex justify-content-center align-items-center">
                <div className="text-center text-999 mb-4">
                  {docLoder ? (
                    <i className="material-icons-outlined fs-1">
                      {" "}
                      <CircularProgress color="inherit" />
                    </i>
                  ) : (
                    <>
                      <i className="material-icons-outlined fs-1"> info </i>
                      <p className="fs-6">{t("No consulted Doctors")}</p>
                    </>
                  )}
                </div>
              </div>
            )}
        </div>
      </div>

      <Snackbar
        open={isError}
        autoHideDuration={3000}
        onClose={() => setIsError(false)}
      >
        <Alert onClose={() => setIsError(false)} severity="error">
          {errorMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ConsultedDoctorsCard;
